'use strict';

/**
 * Check if a value is a correct iban, and optionally populate its BIC into the model.
 */
customerZone.directive('validateIban', [function () {
    var ibanPattern = /^([A-Z]{2}\d{2})([0-9A-Z]{8,30})$/;
    var belgianPattern = /BE\d{2}(\d{3})\d{9}/;

    var alphaToNum = function(input){
        var result = '';
        for (var i=0; i<input.length; i++){
            var char = input[i];
            if (char >= '0' && char <= '9') result += char;
            else result += (input.charCodeAt(i)-55);
        }
        return result;
    };

    var mod9710 = function(validationString) {
        while (validationString.length > 2) {
            var part = validationString.slice(0, 6);
            validationString = (parseInt(part, 10) % 97).toString() + validationString.slice(part.length);
        }
        return parseInt(validationString, 10) % 97;
    };

    var calculateBic = function(fedCode){
        fedCode = parseInt(fedCode, 10);
        var matchingRanges = beBicRanges.filter(function(range){
            return fedCode >= range.from && fedCode <= range.to;
        });
        if (matchingRanges.length > 0)
            return matchingRanges[0].bic;
    };

    var validateChecksum = function(iban){
        var matcher = ibanPattern.exec(iban);
        if (!matcher) return false;
        var check = alphaToNum(matcher[2]+matcher[1]);
        return mod9710(check) === 1;
    };

    var validateLength = function(iban){
        var country = iban.slice(0, 2);
        var expectedLength = knownLengths[country];
        if (!expectedLength) return true;
        return iban.length === expectedLength;
    };

    var beBicRanges = [
        {from: 0, to: 0, bic: 'BPOTBEB1'},
        {from: 1, to: 49, bic: 'GEBABEBB'},
        {from: 50, to: 99, bic: 'GKCCBEBB'},
        {from: 100, to: 101, bic: 'NBBEBEBB203'},
        {from: 103, to: 108, bic: 'NICABEBB'},
        {from: 109, to: 110, bic: 'CTBKBEBX'},
        {from: 111, to: 111, bic: 'ABERBE22'},
        {from: 113, to: 114, bic: 'CTBKBEBX'},
        {from: 119, to: 124, bic: 'CTBKBEBX'},
        {from: 125, to: 126, bic: 'CPHBBE75'},
        {from: 127, to: 127, bic: 'CTBKBEBX'},
        {from: 129, to: 129, bic: 'CTBKBEBX'},
        {from: 131, to: 131, bic: 'CTBKBEBX'},
        {from: 132, to: 132, bic: 'BNAGBEBB'},
        {from: 133, to: 134, bic: 'CTBKBEBX'},
        {from: 137, to: 137, bic: 'GEBABEBB'},
        {from: 140, to: 149, bic: 'GEBABEBB'},
        {from: 150, to: 150, bic: 'BCMCBEBB'},
        {from: 171, to: 171, bic: 'CPHBBE75'},
        {from: 172, to: 173, bic: 'RABOBE23'},
        {from: 176, to: 176, bic: 'BSCHBEBBRET'},
        {from: 177, to: 177, bic: 'BSCHBEBR'},
        {from: 178, to: 179, bic: 'COBABEBX'},
        {from: 183, to: 183, bic: 'BARBBEBB'},
        {from: 185, to: 185, bic: 'HBKABE22'},
        {from: 189, to: 189, bic: 'SMBCBEBB'},
        {from: 190, to: 199, bic: 'CREGBEBB'},
        {from: 200, to: 214, bic: 'GEBABEBB'},
        {from: 220, to: 298, bic: 'GEBABEBB'},
        {from: 299, to: 299, bic: 'BPOTBEB1'},
        {from: 300, to: 399, bic: 'BBRUBEBB'},
        {from: 400, to: 499, bic: 'KREDBEBB'},
        {from: 500, to: 500, bic: 'MTPSBEBB'},
        {from: 501, to: 501, bic: 'DHBNBEBB'},
        {from: 507, to: 507, bic: 'DIERBE21'},
        {from: 508, to: 508, bic: 'PARBBEBZMDC'},
        {from: 509, to: 509, bic: 'ABNABE2AIPC'},
        {from: 510, to: 510, bic: 'VAPEBE22'},
        {from: 512, to: 512, bic: 'DNIBBE21'},
        {from: 513, to: 513, bic: 'SGPBBE99'},
        {from: 514, to: 514, bic: 'PUILBEBB'},
        {from: 515, to: 515, bic: 'IRVTBEBB'},
        {from: 517, to: 517, bic: 'FORDBE21'},
        {from: 519, to: 519, bic: 'BNYMBEBB'},
        {from: 521, to: 521, bic: 'FVLBBE22'},
        {from: 522, to: 522, bic: 'UTWBBEBB'},
        {from: 523, to: 523, bic: 'TRIOBEBB'},
        {from: 524, to: 524, bic: 'WAFABEBB'},
        {from: 525, to: 525, bic: 'FVLBBE2E'},
        {from: 530, to: 530, bic: 'SHIZBEBB'},
        {from: 535, to: 535, bic: 'FBHLBE22'},
        {from: 540, to: 540, bic: 'UBINBE22'},
        {from: 541, to: 541, bic: 'BKIDBE22'},
        {from: 546, to: 546, bic: 'WAFABEBB'},
        {from: 548, to: 548, bic: 'LOCYBEBB'},
        {from: 549, to: 549, bic: 'CHASBEBX'},
        {from: 550, to: 560, bic: 'GKCCBEBB'},
        {from: 561, to: 561, bic: 'FTNOBEB1'},
        {from: 562, to: 569, bic: 'GKCCBEBB'},
        {from: 570, to: 579, bic: 'CITIBEBX'},
        {from: 581, to: 581, bic: 'MHCBBEBB'},
        {from: 583, to: 583, bic: 'DEGRBEBB'},
        {from: 584, to: 584, bic: 'ICICBE2X'},
        {from: 585, to: 585, bic: 'RCBPBEBB'},
        {from: 586, to: 586, bic: 'CFFRBEB1'},
        {from: 587, to: 587, bic: 'BIBLBE21'},
        {from: 588, to: 588, bic: 'CMCIBEB1BTB'},
        {from: 590, to: 594, bic: 'BSCHBEBB'},
        {from: 595, to: 601, bic: 'CTBKBEBX'},
        {from: 605, to: 605, bic: 'BKCHBEBB'},
        {from: 607, to: 607, bic: 'ICBKBEBB'},
        {from: 610, to: 613, bic: 'DEUTBEBE'},
        {from: 615, to: 622, bic: 'BBRUBEBB'},
        {from: 624, to: 625, bic: 'GKCCBEBB'},
        {from: 630, to: 631, bic: 'BBRUBEBB'},
        {from: 634, to: 636, bic: 'BNAGBEBB'},
        {from: 638, to: 638, bic: 'GKCCBEBB'},
        {from: 639, to: 639, bic: 'ABNABE2AMYO'},
        {from: 640, to: 640, bic: 'ADIABE22'},
        {from: 642, to: 642, bic: 'BBVABEBB'},
        {from: 643, to: 643, bic: 'BMPBBEBB'},
        {from: 645, to: 645, bic: 'JVBABE22'},
        {from: 646, to: 647, bic: 'BNAGBEBB'},
        {from: 651, to: 651, bic: 'KEYTBEBB'},
        {from: 652, to: 652, bic: 'HBKABE22'},
        {from: 657, to: 657, bic: 'GKCCBEBB'},
        {from: 658, to: 658, bic: 'HABBBEBB'},
        {from: 663, to: 663, bic: 'BMEUBEB1'},
        {from: 664, to: 664, bic: 'BCDMBEBB'},
        {from: 668, to: 668, bic: 'SBINBE2X'},
        {from: 670, to: 670, bic: 'NYA'},
        {from: 671, to: 671, bic: 'EURBBE99'},
        {from: 672, to: 672, bic: 'GKCCBEBB'},
        {from: 673, to: 673, bic: 'HBKABE22'},
        {from: 674, to: 674, bic: 'ABNABE2AIDJ'},
        {from: 675, to: 675, bic: 'BYBBBEBB'},
        {from: 676, to: 676, bic: 'DEGRBEBB'},
        {from: 677, to: 677, bic: 'CBPXBE99'},
        {from: 678, to: 678, bic: 'DELEBE22'},
        {from: 679, to: 679, bic: 'PCHQBEBB'},
        {from: 680, to: 680, bic: 'GKCCBEBB'},
        {from: 682, to: 683, bic: 'GKCCBEBB'},
        {from: 685, to: 686, bic: 'BOFABE3X'},
        {from: 687, to: 687, bic: 'MGTCBEBE'},
        {from: 688, to: 688, bic: 'SGABBEB2'},
        {from: 693, to: 693, bic: 'BOTKBEBX'},
        {from: 694, to: 694, bic: 'DEUTBEBE'},
        {from: 696, to: 696, bic: 'CRLYBEBB'},
        {from: 698, to: 698, bic: 'NATXBEB1'},
        {from: 700, to: 709, bic: 'AXABBE22'},
        {from: 719, to: 719, bic: 'ABNABE2AXXX'},
        {from: 722, to: 722, bic: 'ABNABE2AIPC'},
        {from: 725, to: 727, bic: 'KREDBEBB'},
        {from: 728, to: 729, bic: 'CREGBEBB'},
        {from: 730, to: 731, bic: 'KREDBEBB'},
        {from: 732, to: 732, bic: 'CREGBEBB'},
        {from: 733, to: 741, bic: 'KREDBEBB'},
        {from: 742, to: 742, bic: 'CREGBEBB'},
        {from: 743, to: 749, bic: 'KREDBEBB'},
        {from: 750, to: 774, bic: 'AXABBE22'},
        {from: 775, to: 799, bic: 'GKCCBEBB'},
        {from: 800, to: 816, bic: 'AXABBE22'},
        {from: 817, to: 817, bic: 'ISAEBEBB'},
        {from: 823, to: 823, bic: 'BLUXBE41'},
        {from: 825, to: 826, bic: 'DEUTBEBE'},
        {from: 828, to: 828, bic: 'HBKABE22'},
        {from: 830, to: 839, bic: 'GKCCBEBB'},
        {from: 840, to: 840, bic: 'PRIBBEBB'},
        {from: 843, to: 843, bic: 'FTNOBEB1'},
        {from: 844, to: 844, bic: 'RABOBE22'},
        {from: 845, to: 845, bic: 'DEGRBEBB'},
        {from: 850, to: 853, bic: 'NICABEBB'},
        {from: 859, to: 860, bic: 'NICABEBB'},
        {from: 862, to: 863, bic: 'NICABEBB'},
        {from: 865, to: 866, bic: 'NICABEBB'},
        {from: 868, to: 868, bic: 'KREDBEBB'},
        {from: 870, to: 872, bic: 'BNAGBEBB'},
        {from: 873, to: 873, bic: 'PCHQBEBB'},
        {from: 874, to: 874, bic: 'BNAGBEBB'},
        {from: 876, to: 876, bic: 'MBWMBEBB'},
        {from: 877, to: 879, bic: 'BNAGBEBB'},
        {from: 880, to: 889, bic: 'HBKABE22'},
        {from: 890, to: 899, bic: 'VDSPBE91'},
        {from: 906, to: 906, bic: 'CEKVBE81'},
        {from: 908, to: 908, bic: 'CEKVBE81'},
        {from: 909, to: 909, bic: 'FTNOBEB1'},
        {from: 910, to: 910, bic: 'HBKABE22'},
        {from: 911, to: 911, bic: 'TUNZBEB1'},
        {from: 913, to: 913, bic: 'EPBFBEBB'},
        {from: 914, to: 914, bic: 'FXBBBEBB'},
        {from: 915, to: 915, bic: 'OONXBEBB'},
        {from: 916, to: 916, bic: 'GOCFBEB1'},
        {from: 920, to: 923, bic: 'HBKABE22'},
        {from: 925, to: 925, bic: 'HBKABE22'},
        {from: 927, to: 927, bic: 'FETALULLBEL'},
        {from: 929, to: 939, bic: 'HBKABE22'},
        {from: 940, to: 940, bic: 'CLIQBEB1'},
        {from: 941, to: 941, bic: 'CVMCBEBB'},
        {from: 942, to: 942, bic: 'PUILBEBB'},
        {from: 944, to: 944, bic: 'NYA'},
        {from: 945, to: 945, bic: 'JPMGBEBB'},
        {from: 949, to: 949, bic: 'HSBCBEBB'},
        {from: 950, to: 959, bic: 'CTBKBEBX'},
        {from: 960, to: 960, bic: 'ABNABE2AIPC'},
        {from: 961, to: 961, bic: 'HBKABE22'},
        {from: 963, to: 963, bic: 'AXABBE22'},
        {from: 968, to: 968, bic: 'ENIBBEBB'},
        {from: 969, to: 969, bic: 'PUILBEBB'},
        {from: 970, to: 971, bic: 'HBKABE22'},
        {from: 973, to: 973, bic: 'ARSPBE22'},
        {from: 975, to: 975, bic: 'AXABBE22'},
        {from: 976, to: 976, bic: 'HBKABE22'},
        {from: 978, to: 980, bic: 'ARSPBE22'},
        {from: 981, to: 984, bic: 'PCHQBEBB'},
        {from: 985, to: 988, bic: 'BPOTBEB1'}
    ];

    var knownLengths = {
        BE: 16
    };

    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var invalid = function(){
                ctrl.$setValidity('iban', false);
                return undefined;
            };
            ctrl.$parsers.push(function(value){
                ctrl.$setValidity('iban', true);
                value = '' + value;
                value = value.replace(/[\s-]+/g, '').toUpperCase();
                if (value === '') return '';
                else if (!value.startsWith('BE')) return value;
                else if (!validateChecksum(value)) return invalid();
                else if (!validateLength(value)) return invalid();
                else {
                    // for a Belgian IBAN we look for a matching BIC
                    // and fill the field for the user
                    var beMatcher = belgianPattern.exec(value);
                    if (beMatcher && attrs['bic']){
                        var previousValue = scope.$eval(attrs['bic']);
                        if (previousValue && previousValue !== '') return value;
                        var bic = calculateBic(beMatcher[1]);
                        if (bic)
                            scope.$eval(attrs['bic'] + ' = \''+bic+'\'');
                    }
                    return value;
                }
            });
        }
    };

}]);
